import { api } from "../apiCore";
import {
  IMemberFL,
  IPassportData,
} from "../../slice/applicationDataToBankSlice/applicationDataToBankSlice";
import { applicationDataToBankApi } from "./applicationBank.api";
import { message } from "antd";

export const individualApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // добавить физ лицо
    addMemberFl: builder.mutation<
      IMemberFL,
      {
        body: Omit<Partial<IMemberFL>, "member_fl"> & Partial<IPassportData>;
        applicationBankId: number;
        applicationId: number;
      }
    >({
      query: (value) => ({
        url: `/auth/applications/system-bank/create-data-to-bank/${value.applicationBankId}/member-fl`,
        method: "POST",
        body: { ...value.body },
      }),
      transformResponse: (response: { data: IMemberFL }) => response.data,
      /* Обработка ошибок */
      transformErrorResponse() {
        message.error("Не получилось добавить учредителя");
      },
      // сохраняем результат мутации в кеш (pessimistic update)
      async onQueryStarted(
        { applicationBankId, applicationId },
        { dispatch, queryFulfilled }
      ) {
        try {
          const { data: updatedFl } = await queryFulfilled;
          // добавление в кэш физ. лица и его паспорт
          dispatch(
            applicationDataToBankApi.util.updateQueryData(
              "getApplicationDataToBank",
              { applicationBankId, applicationId },
              (draft) => {
                // добавление физ. лица
                const updatedFlList = [updatedFl, ...draft.members_fl];
                draft.members_fl = updatedFlList;
                // добавление паспорта физ. лица
                if (updatedFl.member_passport_fl.passport_document)
                  draft.documents.pasportDocument.documents.push(
                    updatedFl.member_passport_fl.passport_document
                  );
              }
            )
          );
          message.success("Учредитель успешно добавлен");
        } catch {}
      },
    }),

    // удалить физ лицо
    deleteMemberFl: builder.mutation<
      IMemberFL,
      {
        applicationId: number;
        applicationBankId: number;
        fl_id: number | string;
      }
    >({
      query: (value) => ({
        url: `/auth/applications/system-bank/create-data-to-bank/${value.applicationBankId}/member-fl/${value.fl_id}`,
        method: "DELETE",
      }),
      // сохраняем результат мутации в кеш (pessimistic update)
      async onQueryStarted(
        { applicationBankId, applicationId, fl_id },
        { dispatch, queryFulfilled }
      ) {
        try {
          await queryFulfilled;
          // удаляем физ. лицо и паспорт из кэша
          dispatch(
            applicationDataToBankApi.util.updateQueryData(
              "getApplicationDataToBank",
              { applicationBankId, applicationId },
              (draft) => {
                // удаляем физ. лицо
                const updatedFlList = draft.members_fl.filter(
                  (fl) => fl.id !== fl_id
                );
                draft.members_fl = updatedFlList;
                // удаляем паспорт
                draft.documents.pasportDocument.documents =
                  draft.documents.pasportDocument.documents.filter(
                    (document) => {
                      return document.member_passport_fl_id !== fl_id;
                    }
                  );
              }
            )
          );
          message.success("Учредитель успешно удалён");
        } catch {
          message.error("Не получилось удалить учредителя");
        }
      },
    }),

    // изменить физ лицо
    changeMemberFl: builder.mutation<
      IMemberFL,
      {
        applicationBankId: number;
        applicationId: number;
        fl_id: number | string;
        body: Omit<Partial<IMemberFL>, "member_fl"> & Partial<IPassportData>;
      }
    >({
      query: (value) => ({
        url: `/auth/applications/system-bank/create-data-to-bank/${value.applicationBankId}/member-fl/${value.fl_id}`,
        method: "PUT",
        body: { ...value.body },
      }),
      transformResponse: (response: { data: IMemberFL }) => response.data,
      //pessimistic update - сохраняем результат мутации в кеш
      async onQueryStarted(
        { applicationBankId, fl_id, applicationId },
        { dispatch, queryFulfilled }
      ) {
        try {
          const { data: updatedFl } = await queryFulfilled;
          // обновляем физ. лицо в кэше
          dispatch(
            applicationDataToBankApi.util.updateQueryData(
              "getApplicationDataToBank",
              { applicationBankId, applicationId },
              (draft) => {
                // обновленный список физ. лиц
                const updatedFlList = draft.members_fl.map((fl) => {
                  if (fl.id === fl_id) {
                    return updatedFl;
                  } else {
                    return fl;
                  }
                });
                // обновляем инфу о паспорте физ. лица
                if (updatedFl.member_passport_fl.passport_document)
                  draft.documents.pasportDocument.documents.map((document) => {
                    const updatedPassportDocument =
                      updatedFl.member_passport_fl.passport_document;
                    if (
                      updatedPassportDocument?.member_passport_fl_id ===
                      document.member_passport_fl_id
                    ) {
                      return updatedPassportDocument;
                    }
                    return document;
                  });
                // добавляем обновленный список физ. лиц в кэш
                draft.members_fl = updatedFlList;
              }
            )
          );

          message.success("Учредитель успешно сохранён");
        } catch {
          message.error("Не получилось сохранить учредителя");
        }
      },
    }),
  }),
});

export const {
  useAddMemberFlMutation,
  useDeleteMemberFlMutation,
  useChangeMemberFlMutation,
} = individualApi;
